// extracted by mini-css-extract-plugin
module.exports = {"itemTotal":"CustomerOrderTable_itemTotal__2bWKb"};